import $ from "jquery";
import { u_ } from "@pressmedia/webappbase";

export default {
	_observer: new IntersectionObserver(entries => entries.forEach(e => {
		const $elm = $(e.target);
		// $elm.toggleClass("is-inview", e.isIntersecting);
		e.isIntersecting && $elm.addClass("is-inview");
		
		const { _inViewCallback } = e.target;
		if( u_.isFunction(_inViewCallback) ) {
			_inViewCallback($elm, e.isIntersecting, e);
		}
	}), {
		threshold: 0.25
	}),
	
	addTarget(elm, callback) {
		if( u_.isFunction(callback) ) {
			elm._inViewCallback = callback;
		}
		
		try {
			this._observer.observe(elm);
		} catch(e) {
			return false;
		}
		
		return true;
	}
};
